var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7131 2.75H10.3069V1.10938C10.3069 0.992188 10.1897 0.875 10.0725 0.875H9.60376C9.45728 0.875 9.36938 0.992188 9.36938 1.10938V2.75H3.74438V1.10938C3.74438 0.992188 3.6272 0.875 3.51001 0.875H3.04126C2.89478 0.875 2.80688 0.992188 2.80688 1.10938V2.75H1.40063C0.609619 2.75 -0.00561523 3.39453 -0.00561523 4.15625V14.4688C-0.00561523 15.2598 0.609619 15.875 1.40063 15.875H11.7131C12.4749 15.875 13.1194 15.2598 13.1194 14.4688V4.15625C13.1194 3.39453 12.4749 2.75 11.7131 2.75ZM12.1819 14.4688C12.1819 14.7324 11.9475 14.9375 11.7131 14.9375H1.40063C1.13696 14.9375 0.931885 14.7324 0.931885 14.4688V6.5H12.1819V14.4688ZM12.1819 5.5625H0.931885V4.15625C0.931885 3.92188 1.13696 3.6875 1.40063 3.6875H11.7131C11.9475 3.6875 12.1819 3.92188 12.1819 4.15625V5.5625ZM3.27563 12.125H6.08813C6.32251 12.125 6.55688 11.9199 6.55688 11.6562V8.84375C6.55688 8.60938 6.32251 8.375 6.08813 8.375H3.27563C3.01196 8.375 2.80688 8.60938 2.80688 8.84375V11.6562C2.80688 11.9199 3.01196 12.125 3.27563 12.125ZM3.74438 9.3125H5.61938V11.1875H3.74438V9.3125Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventIcon);
export default __webpack_public_path__ + "static/media/event-icon.a2db11ab2a25c29c78d774cf5c09ee47.svg";
export { ForwardRef as ReactComponent };